import reducer from './reducers';

export { default as uploadsOperations } from './operations';

export default reducer;
